module.exports = __webpack_public_path__ + "static/media/map_icon_car_offline.8b0d23e8.png";